import $ from "jquery";
import {gsap} from "gsap/all";

export class BlurryLettersAnimation {

  // Constructor
  constructor(selector) {
    this.$el = $(selector);
    this.tl = null;
    this.splitLetters();
    this.buildTimeline();
  }

  splitLetters() {
    this.$el.addClass("blurry-letters-animation");
    const text = this.$el.text();
    this.$el.empty();
    text.split('').forEach((char) => {
      const $span = $('<span>').text(char);
      this.$el.append($span);
    });
  }

  buildTimeline() {
    this.tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 5
    })

    const initialDelay = 5;

    this.tl.to(this.$el.find("span"), {
      filter: "blur(8px)",
      duration: 1.0,
      stagger: {
        each: 0.1,
        from: 'left',
        grid: 'auto',
        ease: 'sine.inOut',
      }
    }, initialDelay);

    this.tl.to(this.$el.find("span"), {
      filter: "blur(0px)",
      duration: 1.0,
      stagger: {
        each: 0.1,
        from: 'left',
        grid: 'auto',
        ease: 'sine.inOut',
      }
    }, initialDelay + 1.2);
  }

  stop() {
    this.tl.pause();
  }

  play() {
    this.tl.restart();
  }

  reset() {
    this.tl.seek(0);
  }

}
